import React from "react";
import { Row, Col, } from "antd";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import CustomNoData from "apps/Common/CustomNoData";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import { useParams } from "react-router-dom";
import { useGetGeneralDopings } from "../ServerSideStates";

const DopingSections = () => {
  const params = useParams()
  const userType = params["userType"]
  // aşağıda normalde 2 olması gerekiyor anacak veri ollmadığı için 1 e çektik ikisinide
  const dopings = useGetGeneralDopings(userType==="bireysel"?1:1)
  return (
    <Row gutter={[0, 40]} className=" ">
      {
        dopings.data?.data?.length>0?<>
        
        {dopings?.data?.data.map((item:any) => {
          return (
            <>
              <Col xs={24} className=" p-6">
                
                <Row gutter={[40, 16]} className="items-center !px-2 lg:!px-6 xxl:!px-16">
                  <Col xs={24} md={12}>
                    <div className="border rounded-md overflow-hidden shadow-lg">
                      <LazyLoadImage
                      imageClassName="!object-contain"
                        src={`${setBackEndUlr("client")}/${item?.icon?.fullPath}`} 
                        alt="sari-ilanlar Screenshot"
                        classNames="w-full"
                        wrapperWidth="100%"
                        wrapperHeight="100%"
                      />
                    </div>
                  </Col>
  
                  <Col xs={24} md={12}>
                    <div className="text-center md:text-left">
                      
  
                      <h3 className="text-xl font-bold mb-4">{item.name}</h3>
                      <p className="text-gray-700 mb-4">{item.shortDescription}</p>
                      <p className="text-gray-500 text-sm mb-6">
                        {item.description}
                      </p>
                      
                    </div>
                  </Col>
                </Row>
              </Col>
            </>
          );
        })}
        </>:<>
        
        <CustomNoData/>
        </>
      }
    </Row>
  );
};

export default DopingSections;
